import script from "./GestisciSensori.vue?vue&type=script&setup=true&lang=js"
export * from "./GestisciSensori.vue?vue&type=script&setup=true&lang=js"

import "./GestisciSensori.vue?vue&type=style&index=0&id=0ba49c57&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0ba49c57"]])

export default __exports__